export class MeterSensorImpulseModel {
  stepInUnit: number;
  initOffset: number;
  key: string;

  constructor() {
    this.stepInUnit = null;
    this.initOffset = null;
    this.key = '';
  }
}
